/* eslint-disable no-alert */
import React, { useEffect, useContext, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { navigate } from '@reach/router';
import _ from 'lodash'

import JobListContext from '../../context/jobListContext';
import GetPMCallsFunction from "../../../functions/GetPMServiceCallsFunction";
import getServiceCallFunction from '../../../functions/GetServiceCallsFunction';
import AppStateContext from '../../context/appStateContext';

import JobsList from '../../components/Lists/cardList';
import PageHeaderHome from '../../components/pageHeaderHome';
import PageLayout from '../../components/pageLayout';
import JobSummaryCardList from '../../components/Lists/jobSummaryCardList';
import SlaIndictorSum from '../../components/slaIndicatorSum';
import ApiStatus, {CALLING,POPULATED,EMPTY} from "../../../components/apiStatus";
import filterHelper from '../../../hooks/useFilterHelper';
import APIHelper from "../../../hooks/useAPIHelper";

import Images from '../../../assets/images';

import {
  ContentCtn,
  FullWidthCtn,
  HeadingCtn,
  LinkToPage,
  PageCtn,
  PageHeaderImgCtn,
  PageHeaderText,
  PlannedListCtn,
  ReactiveListCtn,
} from './index.style';
import GetContractDataList from "../../../functions/GetContractDetailsFunction";

const Home: React.FC<any> = (): React.ReactElement => {

  const { setAppPageDetails, setAppStateDetails, token, selectedCustomerId, siteLogo, setContractCriticalCode, setContractCallers, setContractList, contractList } = useContext(AppStateContext);
  const { filteredReactiveJobList, filteredPlannedJobList, updateFilteredReactiveJobList, updateReactiveJobList, updateFilteredPlannedJobList, updatePlannedJobList } = useContext(JobListContext);

  const [ reactiveApiStatus, setReactiveApiStatus ] = useState(CALLING);
  const [ plannedApiStatus, setPlannedApiStatus ] = useState(CALLING);
  const [ immediateApiStatus, setImmediateApiStatus] = useState(CALLING);
  const [ logo, setLogo ] = useState('');

  const { filterDataByContract } = filterHelper();
  const apiHelper = APIHelper();

  const reactiveCallback = (data: [] | string) => {

    if(data == 'timeout' || data.length == 0) {
      setReactiveApiStatus(EMPTY);
      return;
    }

    updateFilteredReactiveJobList(filterDataByContract(data));
    updateReactiveJobList(filterDataByContract(data));
    setReactiveApiStatus(POPULATED);
  };

  const plannedCallback = (data: [] | string) => {

    if(data == 'timeout' || data.length == 0) {
      setPlannedApiStatus(EMPTY);
      return;
    }

    updateFilteredPlannedJobList(filterDataByContract(data));
    updatePlannedJobList(filterDataByContract(data));
    setPlannedApiStatus(POPULATED);
  };

  const contractListCallback = (data: any[] | string) => {
    let contractDepartments = {};

    data.map((contract) => {
      if(contract.ContractDepartments != "") contractDepartments[contract.ContractNo] = contract.ContractDepartments.ContractDepartment;
    });

    let contractCriticalCodes = data[0].ContractCriticalCodes != ""? data[0].ContractCriticalCodes.ContractCriticalCode: {};

    if(!_.isEmpty(contractCriticalCodes)) {
      setContractCriticalCode(contractCriticalCodes);
    }

    if(Object.keys(contractDepartments).length) {
      setAppStateDetails({
        contractDepartments: contractDepartments,
      })
    }

    if(data.length != 0) {
      setContractCallers(data);
      computeNewContractList(data);
    }
  };

  const computeNewContractList = (data: []) => {
    let newContractDetails = {};
    let contractData = _.assign({},contractList);

    let tempContractList = _.isArray(contractList[selectedCustomerId])? contractList[selectedCustomerId]:  Object.keys(contractList[selectedCustomerId]);

    tempContractList.map((item) => {
      const contractInfo = data.find(element => {
        return element.ContractNo == item;
      });
      if (contractInfo == undefined) return;
      newContractDetails[item] = {
        Description: contractInfo.Description
      };
    });

    contractData[selectedCustomerId] = newContractDetails;
    setContractList(contractData);
  };

  useEffect(() => {
    setAppPageDetails('home');
    updateFilteredPlannedJobList([]);
    setLogo(siteLogo['secondary_logos'][0]['image']['url']);
    apiHelper.run(GetContractDataList, contractListCallback,[token,selectedCustomerId,'']);
    apiHelper.run(getServiceCallFunction, reactiveCallback,['',token,selectedCustomerId]);
    apiHelper.run(GetPMCallsFunction, plannedCallback,['',token, selectedCustomerId]);
  },[]);

  useEffect(() => {

    if(reactiveApiStatus == POPULATED || plannedApiStatus == POPULATED) {
      setImmediateApiStatus(POPULATED);
    }

    if(reactiveApiStatus == EMPTY && plannedApiStatus == EMPTY) {
      setImmediateApiStatus(EMPTY);
    }

  },[reactiveApiStatus, plannedApiStatus]);

  return (
    <PageLayout>
      <PageHeaderHome backgroundImg={siteLogo.background_image[1]['image']['url']}>
        <PageHeaderText>Welcome to our Client portal</PageHeaderText>
        <PageHeaderImgCtn>
          <img src={logo} alt="Aquaheat logo" />
        </PageHeaderImgCtn>
      </PageHeaderHome>
      <PageCtn>
        <ContentCtn>
          <ApiStatus
            disable=''
            type='ring'
            status={immediateApiStatus}
            message='Getting data and computing summary...'
          >
            <FullWidthCtn>
              <JobSummaryCardList />
            </FullWidthCtn>
            <FullWidthCtn>
              <SlaIndictorSum reactiveJobList={filteredReactiveJobList} />
            </FullWidthCtn>
            <ReactiveListCtn>
              <HeadingCtn>
                <span>Recent Reactive Maintenance</span>
                <LinkToPage
                  onClick={(e): void => {
                    e.preventDefault();
                    setAppPageDetails('reactiveMaintenance');
                    navigate('/app/reactiveMaintenance');
                  }}
                >
                  VIEW ALL
                </LinkToPage>
              </HeadingCtn>
              <ApiStatus type='bar' status={reactiveApiStatus}>
                <JobsList itemList={filteredReactiveJobList.slice(0, 4)} page="home" type='reactive'/>
              </ApiStatus>
            </ReactiveListCtn>
            <PlannedListCtn>
              <HeadingCtn>
                <span>Recent Planned Maintenance</span>
                <LinkToPage
                  onClick={(e): void => {
                    e.preventDefault();
                    setAppPageDetails('plannedMaintenance');
                    navigate('/app/plannedMaintenance');
                  }}
                >
                  VIEW ALL
                </LinkToPage>
              </HeadingCtn>
              <ApiStatus status={plannedApiStatus} type="bar">
                <JobsList itemList={filteredPlannedJobList.slice(0,4)} page="home" type='planned'/>
              </ApiStatus>
            </PlannedListCtn>
          </ApiStatus>
        </ContentCtn>
      </PageCtn>
    </PageLayout>
  );
};

export default Home;
